import React from "react"
import { RegisterOptions, useFormContext } from "react-hook-form"
import { getErrorMessage } from "./Errors"

import * as styles from "./RHFTextField.module.css"

export const RHFCheckbox = ({
  name,
  label,
  validation,
  className,
}: {
  name: string
  label?: string
  validation?: RegisterOptions
  className: string
}) => {
  const {
    register,
    formState: { errors, isDirty, isSubmitted },
  } = useFormContext()
  return (
    <div className={className}>
      <div style={{ display: "flex", alignItems: "baseline", gap: 5 }}>
        <input id={name} type="checkbox" {...register(name, validation)} />

        <label htmlFor={name}>{label}</label>
      </div>
      {(isDirty || isSubmitted) && (
        <span className={styles.error}>
          {getErrorMessage(name, errors[name])}
        </span>
      )}
    </div>
  )
}
